import Colors from "@legacy/common/Constants/Colors"
import styled from "styled-components"

export const StudentsAssessmentsContainer = styled.div`
  padding-top: 2rem;
  margin-top: 2rem;
  border-top: 1px solid ${Colors.primary.lightGray};
`